import { useMemo } from "react";
import styles from "./index.module.scss";
import classes from "classnames";

export interface ProgressWithStepperProps {
  currStep: number;
  lastStep: number;
  total: number;
  className?: string;
}

const ProgressWithStepper = ({
  currStep,
  lastStep,
  total = 0,
  className,
}: ProgressWithStepperProps) => {
  const currPercent = useMemo(() => {
    if (total <= 0) {
      return 0;
    }
    const percent = (currStep / total) * 100;
    if (percent === 0) {
      return "10px";
    }
    return percent + "%";
  }, [total, currStep]);

  const lastPercent = useMemo(() => {
    if (total <= 0) {
      return 0;
    }
    const percent = (lastStep / total) * 100;
    if (percent === 0) {
      return "10px";
    }
    return percent + "%";
  }, [total, lastStep]);

  return (
    <div className={classes(styles.progressWithStepper, className)}>
      <div className={styles.progressBar} style={{ width: lastPercent }} />
      <div className={styles.stepperBar} style={{ width: currPercent }} />
    </div>
  );
};

export default ProgressWithStepper;
